export default __webpack_public_path__ + "static/media/profileCatering.44d62344.svg";